export const INITIAL_CATEGORY_COUNT: number = 5;
export const LOCAL_STORAGE_REVIEWS_KEY: string = 'UserCachedReviews';